module.exports = __webpack_public_path__ + "templates/eshop-catalog.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/eshop/templates/eshop-catalog.html
// module id = +DWl
// module chunks = 1